import { deriveIdentifier } from '@retink/types'
import { cn } from '@retink/web-ui'

// Org/tenant slugs are system values derived from the display name — never a
// field the user fills in. This is the read-only echo of what the server will
// derive (the SAME deriveIdentifier transform), so the user sees the identifier
// and, when the name is rejected, the exact reason the server would give.
// Profile 'dns-label' matches the org/tenant slug shape. One component, every
// console create form uses it.

/** True when `name` derives a valid org/tenant (dns-label) identifier. */
export function dnsLabelOk(name: string): boolean {
  return deriveIdentifier(name, 'dns-label').ok
}

export function IdentifierPreview({
  name,
  label = 'Identifier',
  className,
}: {
  name: string
  label?: string
  className?: string
}) {
  if (name.trim() === '') return null
  const { slug, ok, error } = deriveIdentifier(name, 'dns-label')
  if (!ok) {
    return <p className={cn('text-[11px] text-destructive', className)}>{error}</p>
  }
  return (
    <p className={cn('text-[11px] text-muted-foreground', className)}>
      {label}: <span className="font-mono text-foreground">{slug}</span> — created automatically
      from the name.
    </p>
  )
}
